import React, { useEffect } from 'react'
import PageMeta from '../../components/common/PageMeta'
import DefaultTable from '../../components/tables/DefaultTable/DefaultTable'
import { useNavigate } from 'react-router'
import Card from '../../components/common/Card'
import CompanyCreate from './Create/CompanyCreate'
import { useCreate } from '../../context/CreateRegisterContext'
import { useCompany } from '../../context/CompanyContext'
import CompanyForm from './CompanyForm'

export default function Company() {
    const navigate = useNavigate()
    const { companies, loadCompanies } = useCompany()
    const { openCompany, setOpenCompany } = useCreate()

    const columns = [
        {
            key: 'id',
            label: '#'
        },
        {
            key: 'name',
            label: 'Nome da empresa'
        },
        {
            key: 'email',
            label: 'E-mail'
        },
        {
            key: 'phone',
            label: 'Telefone'
        }
    ]

    const handleClick = (row: any) => {
        navigate(`/empresa/${row.id}`)
    }

    useEffect(() => {
        loadCompanies()
    }, [])

    return (
        <>
            <PageMeta title='Empresas | CRM' description='Lista todos as empresas' />
            <div className='space-y-6'>
                <Card>
                    <DefaultTable
                        columns={columns}
                        rows={companies}
                        rowsPerPage={20}
                        handleClick={handleClick}
                        handleCreate={() => setOpenCompany(true)}
                    />
                </Card>
            </div>
            <CompanyForm type='create' open={openCompany} handleClose={() => setOpenCompany(false)} />
        </>
    )
}
